import {isAsset} from "../types/api";
import type {Asset, FocalPointAsset, FromResolver} from "../types/magnolia-types";

export const definePassedOnProps = <T extends {
  asset: FromResolver<Asset | FocalPointAsset>
  format?: string | undefined
}>(props: T): Omit<T, "asset"> => {
  const a = props.asset;
  const p = {...props};
  delete (p as any).asset;
  if (isAsset(a) && a.metadata) {
    // Force any format if a gif is selected as animated formats - as IPX will otherwise stack all the frames in one image.
    if (a.metadata.mimeType === "image/gif" || a.metadata.format === "image/gif") {
      (p as any).format = "webp,gif";
    }
  }
  return p;
};
